import { render, staticRenderFns } from "./NotFoundLayout.vue?vue&type=template&id=27cf2710&"
import script from "./NotFoundLayout.vue?vue&type=script&lang=js&"
export * from "./NotFoundLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/Volumes/ARCHIVE/Source/five9/ps-droids/packages/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27cf2710')) {
      api.createRecord('27cf2710', component.options)
    } else {
      api.reload('27cf2710', component.options)
    }
    module.hot.accept("./NotFoundLayout.vue?vue&type=template&id=27cf2710&", function () {
      api.rerender('27cf2710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/NotFoundLayout.vue"
export default component.exports